// Comprehensive list of UK areas — London neighbourhoods plus major cities & towns across the country.
// Used by both the member Portal and the Editor Studio. Members can also type their own if not listed.
export const LONDON_AREAS = [
  // Central
  "Soho", "Mayfair", "Marylebone", "Fitzrovia", "Covent Garden", "Bloomsbury", "Holborn", "St James's",
  "Pimlico", "Belgravia", "Bayswater", "Paddington", "Victoria", "Westminster", "Barbican", "Aldgate",
  "City of London", "Farringdon", "Clerkenwell", "King's Cross", "Euston", "Waterloo", "Southbank",
  // East
  "Shoreditch", "Hoxton", "Bethnal Green", "Whitechapel", "Spitalfields", "Bow", "Poplar", "Limehouse",
  "Mile End", "Wapping", "Canary Wharf", "Isle of Dogs", "Hackney", "Dalston", "Stoke Newington",
  "Hackney Wick", "Clapton", "Homerton", "London Fields", "Stratford", "Leyton",
  "Leytonstone", "Walthamstow", "Chingford", "Forest Gate", "East Ham", "Plaistow", "Canning Town",
  "Barking", "Dagenham", "Ilford", "Wanstead", "Woodford", "Romford", "Hornchurch", "Upminster",
  // South-East
  "Bermondsey", "Borough", "Bankside", "Shad Thames", "London Bridge", "Peckham", "Nunhead", "Camberwell",
  "Dulwich", "East Dulwich", "Herne Hill", "Deptford", "New Cross", "Greenwich", "Blackheath", "Woolwich",
  "Charlton", "Eltham", "Lee", "Lewisham", "Brockley", "Catford", "Forest Hill", "Sydenham", "Crystal Palace",
  "Bexleyheath", "Welling", "Abbey Wood", "Thamesmead", "Bromley", "Beckenham", "Chislehurst", "Orpington",
  "Penge", "Anerley",
  // South-West
  "Lambeth", "Kennington", "Oval", "Vauxhall", "Stockwell", "Brixton", "Clapham", "Streatham", "Tulse Hill",
  "West Norwood", "Battersea", "Wandsworth", "Balham", "Tooting", "Putney", "Southfields", "Earlsfield",
  "Wimbledon", "Raynes Park", "Colliers Wood", "Morden", "Mitcham", "New Malden", "Kingston upon Thames",
  "Surbiton", "Norbiton", "Richmond", "Twickenham", "Teddington", "Barnes", "Mortlake", "Sheen", "Hampton",
  "Croydon", "Purley", "South Norwood", "Thornton Heath", "Sutton", "Cheam", "Carshalton", "Wallington",
  // West
  "Kensington", "South Kensington", "Chelsea", "Notting Hill", "Holland Park", "Earl's Court", "Fulham",
  "Hammersmith", "Shepherd's Bush", "White City", "Brook Green", "Chiswick", "Acton", "Ealing", "West Ealing",
  "Hanwell", "Southall", "Greenford", "Northolt", "Hounslow", "Brentford", "Isleworth", "Feltham", "Hayes",
  "Uxbridge", "Ruislip", "Hillingdon", "Harrow", "Pinner", "Stanmore", "Wembley", "Willesden", "Kilburn",
  "Cricklewood", "Neasden", "Harlesden", "Maida Vale", "St John's Wood",
  // North
  "Camden Town", "Primrose Hill", "Kentish Town", "Chalk Farm", "Belsize Park", "Hampstead", "Highgate",
  "Gospel Oak", "Tufnell Park", "Islington", "Angel", "Highbury", "Canonbury", "Barnsbury", "Archway",
  "Holloway", "Finsbury Park", "Crouch End", "Muswell Hill", "Wood Green", "Tottenham", "Stroud Green",
  "Harringay", "Palmers Green", "Southgate", "Enfield", "Edmonton", "Barnet", "Finchley", "Golders Green",
  "Hendon", "Mill Hill", "Colindale", "Cockfosters", "New Southgate",
  // Across the UK — major cities & towns (members anywhere can also type their own)
  "Manchester", "Salford", "Birmingham", "Leeds", "Liverpool", "Sheffield", "Newcastle upon Tyne", "Sunderland",
  "Nottingham", "Leicester", "Bristol", "Bath", "Oxford", "Cambridge", "Brighton", "Hove", "Bournemouth",
  "Southampton", "Portsmouth", "Reading", "Milton Keynes", "Norwich", "Ipswich", "Colchester",
  "Chelmsford", "Canterbury", "Maidstone", "Guildford", "St Albans", "Luton", "Watford",
  "Coventry", "Wolverhampton", "Stoke-on-Trent", "Derby", "Northampton", "Peterborough",
  "Hull", "York", "Harrogate", "Bradford", "Huddersfield", "Wakefield", "Doncaster",
  "Preston", "Blackpool", "Lancaster", "Chester", "Warrington", "Bolton", "Stockport",
  "Plymouth", "Exeter", "Truro", "St Ives", "Falmouth", "Torquay", "Cheltenham", "Gloucester",
  "Swindon", "Salisbury", "Winchester", "Worcester", "Hereford", "Shrewsbury", "Telford",
  "Carlisle", "Durham", "Middlesbrough", "Darlington",
  "Edinburgh", "Glasgow", "Aberdeen", "Dundee", "Inverness", "Stirling", "Perth",
  "Cardiff", "Swansea", "Newport", "Wrexham", "Bangor",
  "Belfast", "Derry", "Lisburn",
];
